import Column from '@components/Column';
import CustomBarcode from '@components/CustomBarcode';
import Text from '@components/Text';

import styles from './styles.module.scss';

interface Props {
    couponNo: string;
}

function CouponBarcode({ couponNo }:Props) {
  return (
        <div className={styles.wrapper}>
            <Column className={styles.container} align='center'
                    spacing={6} >
                <CustomBarcode value={couponNo}
                               height={42} />
                <Text>{couponNo}</Text>
            </Column>
        </div>
  );
}
export default CouponBarcode;
